module.exports = __webpack_public_path__ + "media/images/flags/1x1/svn-df8477476b4dfe90d023549b6cdd6924.svg";